module.exports = __webpack_public_path__ + "img/ic_link_preview.5c68ec7a.svg";